import { DateRange } from 'bold-ui'
import { StatusRelatorioEnvioRndsEnum, TipoRegistroRndsEnum } from 'graphql/types.generated'

export interface RndsRelatorioImpressaoModel {
  statusEnvioRegistro: StatusRelatorioEnvioRndsEnum
  periodo: DateRange
  tipoRegistro: TipoRegistroRndsEnum[]
}

export const RELATORIO_RNDS_FILENAME = 'relatorio-rnds'
export const RELATORIO_RNDS_ATMOSPHERE_PATH = 'relatorio-rnds'
